var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.57764 12.7762C8.85295 11.671 11.7971 8.7707 11.7971 5.54704C11.7971 2.89771 9.64937 0.75 7.00004 0.75C4.35071 0.75 2.203 2.89771 2.203 5.54704C2.203 8.7707 5.14712 11.671 6.42243 12.7762C6.75759 13.0666 7.24249 13.0666 7.57764 12.7762Z",
    fill: "white",
    stroke: "#0C0C0C",
    strokeOpacity: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00006 7.23034C8.08517 7.23034 8.96484 6.35068 8.96484 5.26556C8.96484 4.18044 8.08517 3.30078 7.00006 3.30078C5.91494 3.30078 5.03528 4.18044 5.03528 5.26556C5.03528 6.35068 5.91494 7.23034 7.00006 7.23034Z",
    fill: "white",
    stroke: "#0C0C0C",
    strokeOpacity: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.f4aedff1953c3105321a657e97ef242b.svg";
export { ForwardRef as ReactComponent };